import { render } from "./Options.vue?vue&type=template&id=a962242e"
const script = {}
script.render = render

export default script